require('./bootstrap');

/**
 * Flare error tracking for JS
 */
import { flare } from "@flareapp/flare-client";
if (process.env.NODE_ENV === 'production') {
  flare.light('2TcmYvLUuQxxiU7IzEXd8GZWgEYBpNIt');
}

/**
 * General Imports
 */
import "alpinejs";

import * as xc from './scripts/alpine-components'
window.xc = xc;

import * as sc from './scripts/scanner-components'
window.sc = sc;

import * as Pikaday from 'pikaday';
window.Pikaday = Pikaday;

import * as FilePond from 'filepond';
window.FilePond = FilePond;

import * as FilePondPluginImagePreview from 'filepond-plugin-image-preview';
window.FilePondPluginImagePreview = FilePondPluginImagePreview;

import * as FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
window.FilePondPluginFileValidateType = FilePondPluginFileValidateType;

import 'tippy.js/dist/tippy.css';
window.tippy = require('tippy.js').default;
tippy.setDefaultProps({
  arrow: true,
  allowHTML: true,
  placement: 'bottom',
});

import 'nouislider/distribute/nouislider.min.css'
window.noUiSlider = require('nouislider')
